export default {
  title: 'Informations personnelles',
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    personal_info_updated_successfully: 'Vos informations ont été enregistrées avec succès',
  },
};
